import ViewerReportLog from './ViewerReportLog.component';

export default ViewerReportLog;